import styled, { css } from "styled-components";
import { Button } from "antd";
import { ButtonVariant } from ".";

const variantStyle = {
  primary: css`
    background: #1e3665;
    border-color: #1e3665;
    color: #fff;

    &:hover,
    &:focus {
      background: #1e3665 !important;
      border-color: #1e3665 !important;
      color: #fff !important;
    }
  `,

  danger: css`
    background: var(--danger-color);
    border-color: var(--danger-color);
    color: #fff;

    &:hover,
    &:focus {
      background: var(--danger-color) !important;
      border-color: var(--danger-color) !important;
      color: #fff !important;
    }
  `,

  warning: css`
    background: #facc15;
    border-color: #facc15;
    color: #000;

    &:hover,
    &:focus {
      background: #facc15 !important;
      border-color: #facc15 !important;
      color: #000 !important;
    }
  `,
};

export const ButtonWrapper = styled(Button)<{
  $variant: ButtonVariant;
  $borderRadius: string;
  $isCollapse?: boolean;
}>`
  && {
    width: 20px;
    min-height: 104px;
    padding: 0;
    border: none;
    border-radius: ${({ $borderRadius }) => $borderRadius || "4px 0 0 4px"};
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;

    overflow: hidden;

    ${({ $variant }) => variantStyle[$variant]}
  }
  .vertical-text {
    writing-mode: vertical-rl;
    text-orientation: upright;
    letter-spacing: 1px;
  }
`;
